import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import parseId8Message from '../../../../utils/parseId8Message';

import scss from './MessageText.module.scss';

function MessageText({ message }) {
  const { t } = useTranslation('id8');

  const parsedMessage = useMemo(() => parseId8Message(message), [message]);

  return (
    <div className={scss.wrapper}>
      <DataRow label={t('ideaType')} value={parsedMessage.type} />

      {parsedMessage.headline || parsedMessage.transformation ? (
        <div className={scss.dataBlock}>
          {parsedMessage.headline && (
            <DataRow label={t('ideaHeadline')} value={parsedMessage.headline} className={scss.stressed} />
          )}
          {parsedMessage.transformation && <DataRow label={t('transformation')} value={parsedMessage.transformation} />}
        </div>
      ) : null}

      <span className={clsx(scss.dataRow, scss.dataBlock)}>
        <label>{t('manifestation')}:</label>
        <br />
        <span className={scss.unidentifiedText}>{parsedMessage.manifestationsText}</span>
      </span>

      {parsedMessage.unidentified ? <span className={scss.unidentifiedText}>{parsedMessage.unidentified}</span> : null}
    </div>
  );
}

export default MessageText;

const DataRow = ({ label, value, className }) => {
  if (!value) {
    return null;
  }

  return (
    <span className={clsx(scss.dataRow, className)}>
      {label}: {value}
    </span>
  );
};
